import './Tie.scss'

import { usePage } from './PageContext';

import { useEffect, useRef, useState } from 'react';

const setTheme = (page) => {
    // Remove old theme.
    for (let className of document.body.classList) {
        if (className.startsWith('theme-')) {
            document.body.classList.remove(className);
        }
    }
    // Set new theme.
    if (page === "Software Engineer") {
        document.body.classList.add('theme-beach');
    } else if (page === "Actor") {
        document.body.classList.add('theme-crayon');
    }
}

const getContent = (page) => {
    if (page === "Software Engineer") {
        return [
            {text: "About Me", href: "#about"},
            {text: "Portfolio", href: "#portfolio"},
            {text: "Résumé", href: "/resume.pdf"}
        ];
    } else if (page === "Actor") {
        return [
            {text: "About Me", href: "#about"},
            {text: "Pictures", href: "#pictures"},
            {text: "Résumé", href: "/actingResume.pdf"}
        ];
    } else {
        return [];
    }
}

const Tie = () => {
    const { page, canPageChange } = usePage();

    const tie = useRef();

    const [tagContent, setTagContent] = useState(getContent());
    
    const doEffect = canPageChange.current;
    useEffect(() => {
        if (!doEffect) {
            setTagContent(getContent(page));
            setTheme(page);
            return;
        }
        // Move the tie.
        tie.current.style.translate = "0px -100vh";
        // Wait for the movement transition to end.
        tie.current.addEventListener('transitionend', function handler(event) {
            if (event.propertyName !== 'translate') return;
            tie.current.removeEventListener('transitionend', handler);
            // Set the new theme.
            setTheme(page);
            setTagContent(getContent(page));
            // Move the tie back.
            setTimeout(() => {
                tie.current.style.translate = "0px 0px";
            }, 200);
        });
    }, [page]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <div className="tie" ref={tie}>
            <div className="content">
                <div className="header">
                    <h1>Benson Haley</h1>
                    <div>{page}</div>
                </div>
                <div className="navigation">
                    <div className="box"></div>
                    <div className="text">
                        {
                            tagContent.map((content) => {
                                return content.href[0] === "#"
                                    ? <h2 key={content.text}><a className="special" href={content.href}>{content.text}</a></h2>
                                    : <h2 key={content.text}><a className="special" href={content.href} target="_blank" rel="noreferrer">{content.text}</a></h2>
                                
                            })
                        }
                    </div>
                </div>
            </div>
            <div className="bar"></div>
        </div>
    );
}

export default Tie;